import * as React from 'react';

import { HELP_ARTICLE_LINKS } from '@showbie-socrative/socrative-utils/lib/consts/constants';
import { translate } from '~l10n/client';

import { AlertMessage } from '~shared/components/AlertMessage';
import { Divider } from '~shared/components/Divider';
import { FieldRow } from '~shared/components/FieldRow';
import { Stack } from '~shared/components/Stack';
import ToggleSwitch from '~shared/components/ToggleSwitch/ToggleSwitch';

import { Pending } from '../ExportReports/ExportFeedback/ExportFeedbackIcons';

interface Props {
  isRequestInProgress: boolean;
  isIncludeExplanationsToggled: boolean;
  isIncludeCorrectAnswersToggled: boolean;
  handleIncludeCorrectAnswersToggle: () => void;
  handleIsIncludeExplanationToggle: () => void;
  hideToggleOptions: boolean;
}
const EmailStudentsOptions: React.FC<Props> = ({
  isRequestInProgress,
  isIncludeExplanationsToggled,
  isIncludeCorrectAnswersToggled,
  handleIncludeCorrectAnswersToggle,
  handleIsIncludeExplanationToggle,
  hideToggleOptions,
  children,
}: React.PropsWithChildren<Props>) => {
  return (
    <div className="flex flex-col justify-between h-full">
      {isRequestInProgress ? (
        <div className="flex h-full items-center justify-center">
          <Pending />
        </div>
      ) : (
        <>
          {hideToggleOptions ? (
            <div className="pt-8">
              <AlertMessage tone="info" showIcon>
                <span
                  style={{ color: 'inherit' }}
                  dangerouslySetInnerHTML={{
                    __html:
                      translate(
                        `<strong>Pro tip:</strong> add email addresses to your student roster to make emailing student reports quick and easy!`
                      ) + ' ',
                  }}
                />
                <a
                  className="alert-message__link"
                  href={HELP_ARTICLE_LINKS.EMAIL_STUDENT_REPORTS}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {translate('Learn More')}
                </a>
              </AlertMessage>
            </div>
          ) : (
            <div className="flex flex-col flex-1 pt-8">
              <Divider />
              <Stack dividers>
                <FieldRow
                  label={translate('Include Explanations')}
                  id="explanation-toggle"
                >
                  <ToggleSwitch
                    id="explanation-toggle"
                    labelledBy="explanation-toggle-label"
                    on={isIncludeExplanationsToggled}
                    onChange={handleIsIncludeExplanationToggle}
                  />
                </FieldRow>
                <FieldRow
                  label={translate('Include Correct Answers')}
                  id="answers-toggle"
                >
                  <ToggleSwitch
                    id="answers-toggle"
                    labelledBy="answers-toggle-label"
                    on={isIncludeCorrectAnswersToggled}
                    onChange={handleIncludeCorrectAnswersToggle}
                  />
                </FieldRow>
              </Stack>
              <Divider />
            </div>
          )}
          {children}
        </>
      )}
    </div>
  );
};

export default EmailStudentsOptions;
